import { Switch, SwitchColorEnum } from '@acceso/design-system';
import clsx from 'clsx';
import { Controller, FieldValues, Path, UseFormReturn } from 'react-hook-form';

type TStateFormProps<T extends FieldValues> = {
  form: UseFormReturn<T>;
  name: Path<T>;
  disabled?: boolean;
  activedName: string;
  desactivedName: string;
  className?: string;
  leftLabelPosition?: boolean;
  color?: SwitchColorEnum;
};

export function StateForm<T extends FieldValues>({
  form,
  name,
  disabled,
  activedName,
  desactivedName,
  className,
  leftLabelPosition,
  color = SwitchColorEnum.SUCCESS,
}: TStateFormProps<T>) {
  const { control } = form;

  return (
    <div className={clsx('flex w-full justify-end', className)}>
      <Controller
        name={name}
        control={control}
        render={({ field: { value, onChange } }) => (
          <Switch
            color={color}
            checked={value === 1}
            onChange={() => onChange(value === 1 ? 0 : 1)}
            startLabel={
              leftLabelPosition ? (value === 1 ? activedName : desactivedName) : undefined
            }
            endLabel={!leftLabelPosition ? (value === 1 ? activedName : desactivedName) : undefined}
          />
        )}
        disabled={disabled}
      />
    </div>
  );
}
